jQuery( document ).ready(function($) {
    let main_menu_wrapper = jQuery("#main-menu-wrapper");
    let mobile_menu_toggle = jQuery('#primary-menu-toggle button');
    let bangor_arc_story = jQuery( '#bangor-arc-story' );

    mobile_menu_toggle.on( 'click', function() {
        main_menu_wrapper.toggleClass( 'expanded' );
    } );
    
    pma_handle_primary_menu_rollovers();

    bangor_arc_story.on( 'click', function() {
        var bangor_arc_story_lightbox = lity( 'https://storymaps.arcgis.com/stories/84617eb8b5d64786b033f7e19344ea7b?header' );
    } );

});

function pma_handle_primary_menu_rollovers() {
    let sub_menu_parents = jQuery("#menu-main-menu .menu-item-has-children");
    let disabled_links = jQuery(".disable-link > a");

    sub_menu_parents.on( "mouseover", function(event) {
        jQuery(this).addClass("expanded");
    } );
    sub_menu_parents.on( "mouseout", function(event) {
        jQuery(this).removeClass("expanded");
    } );

    disabled_links.on("click", function() {
        return false;
    });
}